import React from 'react'
import { Element, Heading } from 'react-bulma-components'

export interface Action {
  title: React.ReactNode
  description?: React.ReactNode
  content: React.ReactNode
}

interface ResourceActionsProps {
  actions: Action[]
}

/**
 * Component to display a list of actions for a resource
 */
const ResourceActions: React.FC<ResourceActionsProps> = ({ actions }) => {
  return (
    <>
      {actions.map((action, index) => (
        <Element key={index} mb={index !== actions.length - 1 ? 5 : 0}>
          <Heading size={5} mb={2}>
            {action.title}
          </Heading>
          <Element mb={2}>{action.description}</Element>
          {action.content}
          {index !== actions.length - 1 && <Element renderAs="hr" my={5} />}
        </Element>
      ))}
    </>
  )
}

export default ResourceActions
